const EatingCake = () => (
    <section id="eating-cake">
        <div className="container-fluid py-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-9 col-11">
                    <p className="fs-4 lh-sm">
                        And then I saw it.<br/>
                        <b>She was eating cake.</b><br/>
                        Not a sugar-free, cardboard-tasting "diabetic" version.<br/>
                        No, this was real, frosting-dripping birthday cake.<br/>
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default EatingCake;